import { useTranslation } from 'react-i18next';
import {
    Card,
} from '@material-ui/core';
import CircularProgressWithLabel from '../../../../ZaddonsJSLibs/common-client2/src/components/CircularProgressWithLabel';
import { PublishStatusClassNames } from '../../Enums';
import {
    getSummaryPublishStatusTypeHeaderLabel,
    getSummaryPublishStatusTypeDescriptionLabel,
} from '../../Enums/Helpers/LabellingHelper';
import './ProgressSummary.scss';

/**
 * @param {{
 * workplanName: string,
 * effectiveDate: string,
 * endDate: string,
 * isForeverRequestPeriod: boolean,
 * publishStatusType: import('../../Enums/PublishStatusType').default,
 * progressValue: number,
 * }} param0
 */
function ProgressSummary({
    workplanName,
    effectiveDate,
    endDate,
    isForeverRequestPeriod,
    publishStatusType,
    progressValue,
}) {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'manager.bidProfileEdit.bidDashboard.publishProgress.summary' });
    return (
        <Card>
            <div className="ps--content">
                <div className="headline-h-700 ps-title">
                    {t('header', { workplanName })}
                    <div className="ps-progress">
                        <CircularProgressWithLabel
                            // @ts-ignore
                            size={40}
                            value={progressValue}
                        />
                    </div>
                </div>
                <div className="ps-dates">
                    <span className="left">
                        <span className="text-md-regular field-label">
                            {t('effectiveDate')}
                        </span>
                        <span className="text-md-medium field-value">
                            {effectiveDate}
                        </span>
                    </span>
                    <span className="right">
                        <span className="text-md-regular field-label">
                            {t('endDate')}
                        </span>
                        <span className="text-md-medium field-value">
                            {isForeverRequestPeriod ? t('endDateForever') : endDate}
                        </span>
                    </span>
                </div>
                <div className={`ps-status-container ${PublishStatusClassNames[publishStatusType]}`}>
                    <span className={`text-md-semibold ${PublishStatusClassNames[publishStatusType]}`}>
                        {getSummaryPublishStatusTypeHeaderLabel(publishStatusType)}
                    </span>
                    <span className={`text-md-regular ${PublishStatusClassNames[publishStatusType]}`}>
                        {getSummaryPublishStatusTypeDescriptionLabel(publishStatusType)}
                    </span>
                </div>
            </div>
        </Card>
    );
}

export default ProgressSummary;
